import { privilegeHumanizer } from './privileges'

export default privilegeHumanizer
